import { spacingVars } from '@tundr/ds-foundations';
import { style } from '@vanilla-extract/css';

export const infoTooltipCellClass = style({
  display: 'inline-flex',
  alignItems: 'center',
  gap: spacingVars.xs,
});
